// Central SEO configuration — repositioned around Employee Relations & People Risk.
export const SITE_URL = "https://ishikadvisory.com";
export const SITE_NAME = "Irina Ishik | Employee Relations & People Risk Advisory";
export const DEFAULT_DESCRIPTION =
  "Independent Employee Relations and People Risk advisory for HR leaders navigating complex cases, workplace investigations and scalable ER frameworks across Dubai, the UAE and Middle East.";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

// Paste your IDs here to activate them (all optional):
export const GA4_ID = "G-6RVHBKNYK5";            // Google Analytics 4
export const GSC_VERIFICATION = "";  // (already added directly in public/index.html)
export const BING_VERIFICATION = ""; // msvalidate.01 content value

export const businessLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#business`,
  name: "Irina Ishik — Employee Relations & People Risk Advisory",
  url: `${SITE_URL}/`,
  image: OG_IMAGE,
  description:
    "Independent, senior Employee Relations and People Risk advisory helping HR leaders navigate complex, sensitive and high-stakes employee cases, workplace investigations, and the design of scalable ER frameworks across Dubai, the UAE and the wider Middle East.",
  areaServed: ["Dubai", "United Arab Emirates", "Middle East", "GCC", "Europe"],
  email: "irina@ishikadvisory.com",
  telephone: "+971507736237",
  address: { "@type": "PostalAddress", addressLocality: "Dubai", addressCountry: "AE" },
  knowsAbout: [
    "Employee Relations", "People Risk", "Workplace Investigations", "Sensitive Employee Cases",
    "ER Framework Design", "ER Capability Assessment", "Grievance and Disciplinary Process",
    "Misconduct Investigation", "HR Governance", "Fractional Head of Employee Relations",
  ],
};

export const personLd = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": `${SITE_URL}/#irina`,
  name: "Irina Ishik",
  jobTitle: "Employee Relations & People Risk Advisor",
  url: `${SITE_URL}/`,
  image: OG_IMAGE,
  worksFor: { "@id": `${SITE_URL}/#business` },
  description:
    "Senior HR and Employee Relations professional with 20+ years advising HR leaders and boards on complex employee cases, workplace investigations and people risk across the Middle East and international markets.",
  knowsAbout: [
    "Employee Relations", "Workplace Investigations", "People Risk", "ER Governance",
    "Sensitive Case Advisory", "ER Operating Models",
  ],
};

export const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: `${SITE_URL}/`,
  name: SITE_NAME,
  publisher: { "@id": `${SITE_URL}/#business` },
};

export function articleLd(article) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.excerpt,
    image: article.cover_image ? [article.cover_image] : [OG_IMAGE],
    articleSection: article.category,
    datePublished: article.created_at,
    dateModified: article.updated_at || article.created_at,
    author: { "@type": "Person", name: article.author || "Irina Ishik", url: `${SITE_URL}/` },
    publisher: { "@type": "Organization", name: "Irina Ishik", logo: { "@type": "ImageObject", url: OG_IMAGE } },
    mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE_URL}/insights/${article.slug}` },
  };
}

export function serviceLd(service) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.h1,
    serviceType: service.serviceType,
    description: service.metaDescription,
    areaServed: ["Dubai", "United Arab Emirates", "Middle East", "GCC"],
    provider: { "@type": "ProfessionalService", "@id": `${SITE_URL}/#business`, name: "Irina Ishik — Employee Relations & People Risk Advisory" },
    url: `${SITE_URL}/${service.slug}`,
  };
}

export function faqLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}
